export enum PAYRUN_AUTHORIZATION_CLAIMS {
  payrunEditButton = "payrunEditButton",
  payrunSkipButton = "payrunSkipButton",
  payrunReimportButton = "payrunReimportButton",
  payrunRegeneratePdfButton = "payrunRegeneratePdfButton",
  payrunReimportAbaButton = "payrunReimportAbaButton",
}
